export const GET_IMPAYES = "GET_IMPAYES";
export const GET_IMPAYES_COMPLETED = "GET_IMPAYES_COMPLETED";
export const GET_IMPAYES_FAILED = "GET_IMPAYES_FAILED";

export const GET_RECOUVREMENT_CONSTANTS = "GET_RECOUVREMENT_CONSTANTS";
export const GET_RECOUVREMENT_CONSTANTS_COMPLETED = "GET_RECOUVREMENT_CONSTANTS_COMPLETED";
export const GET_RECOUVREMENT_CONSTANTS_FAILED = "GET_RECOUVREMENT_CONSTANTS_FAILED";

export const GET_IMPAYE_DETAIL = "GET_IMPAYE_DETAIL";
export const GET_IMPAYE_DETAIL_COMPLETED = "GET_IMPAYE_DETAIL_COMPLETED";
export const GET_IMPAYE_DETAIL_FAILED = "GET_IMPAYE_DETAIL_FAILED";

export const POST_RECOUVREMENT_NOTE = "POST_RECOUVREMENT_NOTE";
export const PATCH_RECOUVREMENT_STATUT = "PATCH_RECOUVREMENT_STATUT";
export const POST_RECOUVREMENT_RELANCE = "POST_RECOUVREMENT_RELANCE";
export const GET_RECOUVREMENT_BROUILLON = "GET_RECOUVREMENT_BROUILLON";
export const GET_RECOUVREMENT_BROUILLON_COMPLETED = "GET_RECOUVREMENT_BROUILLON_COMPLETED";

export const MARK_GROUPED_PAID = "MARK_GROUPED_PAID";

// Enregistre le paiement d'une commande groupée en renseignant « Payé le ».
// Réutilise l'endpoint existant du listing devis : le VosFacturesSubscriber
// crée alors le paiement sur VosFactures et passe la facture en payé (203).
export const markGroupedPaid = (groupedOrderId, paidDate) => ({
  type: MARK_GROUPED_PAID,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/${groupedOrderId}/grouped.json`,
    method: "PUT",
    body: { paid_date: paidDate },
  },
});

export const getImpayes = (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters || {}).filter(([, v]) => v !== null && v !== undefined && v !== "")
  );
  return {
    type: GET_IMPAYES,
    meta: {
      async: true,
      blocking: false,
      path: `/api/recouvrement/impayes.json`,
      method: "GET",
      params,
    },
  };
};

export const getRecouvrementConstants = () => ({
  type: GET_RECOUVREMENT_CONSTANTS,
  meta: {
    async: true,
    blocking: false,
    path: `/api/recouvrement/constants.json`,
    method: "GET",
    params: {},
  },
});

export const getImpayeDetail = (groupedOrderId) => ({
  type: GET_IMPAYE_DETAIL,
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/${groupedOrderId}.json`,
    method: "GET",
    params: {},
  },
});

export const postRecouvrementNote = (groupedOrderId, contenu) => ({
  type: POST_RECOUVREMENT_NOTE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/${groupedOrderId}/note.json`,
    method: "POST",
    body: { contenu },
  },
});

// Relance multi-factures : brouillon (texte + email proposé) puis enregistrement.
export const getRelanceMultipleBrouillon = (groupedIds) => ({
  type: "GET_RELANCE_MULTIPLE_BROUILLON",
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/relance-multiple-brouillon.json`,
    method: "POST",
    body: { grouped_ids: groupedIds },
  },
});

export const postRelanceMultiple = (groupedIds, email) => ({
  type: "POST_RELANCE_MULTIPLE",
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/relance-multiple.json`,
    method: "POST",
    body: { grouped_ids: groupedIds, email: email || null },
  },
});

// Action groupée de suivi (statut / chargé de clientèle / prochaine action /
// note) appliquée d'un coup à plusieurs factures sélectionnées.
// Seules les clés présentes dans `payload` sont modifiées côté API.
export const postRecouvrementActionsGroupees = (groupedIds, payload) => ({
  type: "POST_RECOUVREMENT_ACTIONS_GROUPEES",
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/actions-groupees.json`,
    method: "POST",
    body: { grouped_ids: groupedIds, ...payload },
  },
});

export const patchRecouvrementStatut = (groupedOrderId, payload) => ({
  type: PATCH_RECOUVREMENT_STATUT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/${groupedOrderId}/statut.json`,
    method: "PUT",
    body: payload,
  },
});

export const postRecouvrementRelance = (groupedOrderId, note = null) => ({
  type: POST_RECOUVREMENT_RELANCE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/recouvrement/${groupedOrderId}/relance.json`,
    method: "POST",
    body: note ? { note } : {},
  },
});

export const getRecouvrementBrouillon = (groupedOrderId, niveau = null) => {
  const params = {};
  if (niveau) params.niveau = niveau;
  return {
    type: GET_RECOUVREMENT_BROUILLON,
    meta: {
      async: true,
      blocking: true,
      path: `/api/recouvrement/${groupedOrderId}/relance-brouillon.json`,
      method: "GET",
      params,
    },
  };
};
